import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import ArticleGrid from './components/ArticleGrid';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <ContentSection />
        <ArticleGrid />
        <FAQSection />
      </main>
      <Footer />

      {/* Website Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'VigorBuy Spreadsheet Guide',
            url: import.meta.env.VITE_SITE_URL,
            description: 'Comprehensive resource for VigorBuy Spreadsheet reviews, comparisons, templates, and expert guides.',
            potentialAction: {
              '@type': 'SearchAction',
              target: import.meta.env.VITE_SITE_URL + '/?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is VigorBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'VigorBuy Spreadsheet is a comprehensive spreadsheet platform designed to help individuals and businesses manage data efficiently. It provides powerful tools for organizing information, creating templates, automating workflows, and generating insightful reports.',
                },
              },
              {
                '@type': 'Question',
                name: 'Is VigorBuy Spreadsheet safe to use?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes, VigorBuy Spreadsheet prioritizes data security and user privacy. The platform employs industry-standard encryption protocols to protect your information during transmission and storage. Regular security audits and updates ensure that your data remains protected against emerging threats.',
                },
              },
              {
                '@type': 'Question',
                name: 'How does VigorBuy Spreadsheet compare to Microsoft Excel?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'While both tools offer robust spreadsheet capabilities, VigorBuy Spreadsheet distinguishes itself with a more intuitive interface and specialized templates designed for modern business workflows. Unlike Excel, which requires significant training for advanced features, VigorBuy Spreadsheet emphasizes ease of use without sacrificing functionality.',
                },
              },
              {
                '@type': 'Question',
                name: 'What templates are available in VigorBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'VigorBuy Spreadsheet includes a wide range of ready-to-use templates covering business management, financial planning, inventory tracking, project management, marketing analytics, and personal productivity. Each template is professionally designed and fully customizable.',
                },
              },
              {
                '@type': 'Question',
                name: 'Can I use VigorBuy Spreadsheet for my small business?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Absolutely. VigorBuy Spreadsheet is particularly well-suited for small businesses. It offers affordable access to professional-grade spreadsheet tools without the complexity or cost of enterprise software. Small business owners can use it for bookkeeping, CRM, sales tracking, expense monitoring, and performance reporting.',
                },
              },
              {
                '@type': 'Question',
                name: 'Does VigorBuy Spreadsheet support team collaboration?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes, collaboration is a core feature of VigorBuy Spreadsheet. Multiple team members can work on the same spreadsheet simultaneously, with real-time updates and change tracking. You can set different permission levels for viewers, editors, and administrators.',
                },
              },
              {
                '@type': 'Question',
                name: 'What are the system requirements for VigorBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'As a cloud-based platform, VigorBuy Spreadsheet works on any modern web browser without requiring software installation. It is compatible with Windows, macOS, Linux, and ChromeOS. For the best experience, we recommend using the latest version of Chrome, Firefox, Safari, or Edge with a stable internet connection.',
                },
              },
              {
                '@type': 'Question',
                name: 'How do I get started with VigorBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Getting started is straightforward. Simply visit the official website, create an account, and you can begin exploring the available templates and features immediately. The platform includes guided tutorials and documentation to help new users familiarize themselves with the tools.',
                },
              },
            ],
          }),
        }}
      />
    </div>
  );
}